<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'我的门票' | dealLanguage('My Tickets')}}</page-header>
    <div class="flex-wrapper">
      <div class="flex-left">
        <user-info-nav></user-info-nav>
      </div>
      <div class="flex-right">
        <div class="view-title">
          <div class="title">{{'本人的门票' | dealLanguage('My Tickets')}}</div>
          <div class="line"></div>
        </div>
        <div class="ticket-list">
          <div v-for="item,index in myticket" :key="index">
            <div class="ticket-item ticket-container">
              <div class="ticket-item-top">
                <div class="ticket-item-top-left">
                  <img :src="item.activityShareImagePath | logo_show" />
                  <!-- <img :src="item.activityLogoPath | logo_show" /> -->
                </div>
                <div class="ticket-item-top-right">
                  <div>
                    <div class="title">{{item.activityTicketName | dealLanguage(item.activityEnTicketName)}}</div>
                    <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                    <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                  </div>
                  <div class="source" v-if="item.giveXuserid">{{`受赠于` | dealLanguage(`From`)}} {{item.giveXuserName}} {{item.giveXuserMobile}}</div>
                </div>
              </div>
              <!-- 参会人信息 -->
              <div class="participant" v-if="language == 'zh'">参会人信息：{{user.name}} +{{user.mobileAreaCode}} {{user.mobile}}</div>
              <div class="participant" v-else>Participant information:{{user.email}}</div>
              <div class="bottom-btn-wrapper">
                <Button @click="handleLook(item.ticketUserRelationId)">{{'查看详情' | dealLanguage('Details')}}</Button>
                <!-- <Button>发送短信通知</Button> -->
                <Button type="primary" @click="handleChangeRouter('signUp')">{{'升级门票' | dealLanguage('Upgrade')}}</Button>
              </div>
            </div>
          </div>
        </div>
        <div class="more-btn" v-if="!loading && isMore">
          <Button @click="getMore">{{'加载更多' | dealLanguage('More')}}</Button>
        </div>
        <div class="loading-warpper" v-if="loading">
          <van-loading size="20px">{{'加载中' | dealLanguage('Loading')}}...</van-loading>
        </div>
        <nothing v-if="!isMore && !loading && myticket.length == 0">
          <router-link :to="{name: 'signUp'}" class="btn">{{'前往购票' | dealLanguage('Get tickets')}}</router-link>
        </nothing>

        <div class="list">
          <div class="list-item" v-for="(pitem, pindex) in partnerTicket" :key="pindex">
            <div class="view-title">
              <div class="title">{{pitem.partnerName}}{{'的门票' | dealLanguage("'s Tickets")}}</div>
              <div class="line"></div>
            </div>
            <div class="ticket-list">
              <div v-for="item,index in pitem.ticketList" :key="index">
                <div class="ticket-item ticket-container">
                  <div class="ticket-item-top">
                    <div class="ticket-item-top-left">
                      <img :src="item.activityShareImagePath | logo_show" />
                    </div>
                    <div class="ticket-item-top-right">
                      <div>
                        <div class="title">{{item.activityTicketName | dealLanguage(item.activityEnTicketName)}}</div>
                        <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                        <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 参会人信息 -->
                  <div class="participant">{{'参会人信息：' | dealLanguage('Participant information:')}}{{pitem.partnerName}} +{{pitem.partnerMobileAreaCode}} {{pitem.partnerMobile}}</div>
                  <div class="bottom-btn-wrapper">
                    <Button @click="handleLook(item.ticketUserRelationId)">{{'查看详情' | dealLanguage('Details')}}</Button>
                    <Button @click="sendTicketMsg(item.ticketUserRelationId)">{{'发送短信通知' | dealLanguage('SMS Notify')}}</Button>
                    <Button type="primary" @click="handleChangeRouter('signUp')">{{'升级门票' | dealLanguage('Upgrade')}}</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div ref="indexlist-bottom"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import PageHeader from '@/components/pc/pageHeader.vue'
import UserInfoNav from '@/components/pc/userInfoNav.vue'
import { myticket, partnerTicket, sendTicketMsg } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('我的门票', 'My Tickets'),
    }
  },
  components: {
    PageHeader,
    UserInfoNav,
    Nothing,
  },
  created() {
    this.getTicket()
    this.getPartnerTicket()
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      myticket: [],
      loading: false,
      isMore: false,
      partnerTicket: [],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  methods: {
    // handleScroll() {
    //   let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

    //   const listbox = this.$refs['indexlist-bottom']
    //   const listrect = listbox.getBoundingClientRect()
    //   const listabsoluteTop = listrect.top + scrollTop
    //   if (
    //     scrollTop + windowHeight >= listabsoluteTop &&
    //     scrollTop > 0 &&
    //     !this.loading &&
    //     this.isMore
    //   ) {
    //     this.getMore()
    //   }
    // },
    async getTicket() {
      this.loading = true
      let res = await myticket({
        page: this.page,
        dataType: 2,
        size: 10,
        ticketStatus: 0,
      })
      this.loading = false
      if (res.code == 0) {
        this.myticket = [...this.myticket, ...res.data]
        this.isMore = res.data.length == 10
      }
    },
    async getPartnerTicket() {
      let res = await partnerTicket({
        activityId: this.activityId,
        dataType: 2,
        ticketStatus: 0,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'partnerTicket', res.data.partnerTicketInfos)
      }
    },
    async sendTicketMsg(rowId) {
      let res = await sendTicketMsg({
        ticketUserRelationId: rowId
      })
      if (res.code == 0) {
        this.$Message.success(filter.dealLanguage('发送成功！', 'Send successfully'))
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    getMore() {
      this.page++
      this.getTicket()
    },
    handleLook(rowId) {
      this.$router.push({ name: 'ticketDetail', params: { id: rowId } })
    },
    handleChangeRouter(name) {
      this.$router.push({ name })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
@import '~styles/ticket-item.styl'
.list
  margin-top 20px
  > .list-item + .list-item
    margin-top 20px
.flex-right
  padding 30px 120px 30px 0
  .more-btn
    margin-top 20px
    font-size 0
    text-align center
    .ivu-btn
      color #C8161D
      box-shadow none
      transition all 0.3s
      font-size 14px
      padding 0
      height auto
      border 0
      &:hover
        color #E24147
  .ticket-list
    display flex
    flex-wrap wrap
    margin-top 10px
    > div
      max-width 390px
      min-width 390px
      &:not(:nth-of-type(2n+1))
        margin-left 20px
      &:nth-of-type(n+3)
        margin-top 20px
      .ticket-item
        padding 15px 20px 78px
        display flex
        flex-direction column
        justify-content space-between
        .desc
          margin 10px 0 0
        .bottom-btn-wrapper
          position absolute
          bottom 17px
          left 20px
          right 20px
</style>